import React from "react";
import SortableHandle from "src/components/Sortable/Handle";
import PostItContainer from "./styles";

interface ISimplePostIt{
  color: string;
}

const SimplePostIt: React.FC<ISimplePostIt> = ({
	color
}) => (
	<>
		<SortableHandle>
			<PostItContainer background={color} />
		</SortableHandle>	
	</>
);

export default SimplePostIt;
